module.exports = __webpack_public_path__ + "img/f5984f9.jpg";